import { render, staticRenderFns } from "./KimmuJissekiK.vue?vue&type=template&id=06461f51&scoped=true"
import script from "./KimmuJissekiK.vue?vue&type=script&lang=js"
export * from "./KimmuJissekiK.vue?vue&type=script&lang=js"
import style0 from "./KimmuJissekiK.vue?vue&type=style&index=0&id=06461f51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06461f51",
  null
  
)

export default component.exports